import { useState, useEffect, useCallback, useMemo } from 'react';
import { TicketType, TicketSeverity } from '../../../types/ticket';

interface UseTicketFiltersReturn {
  title: string;
  debouncedTitle: string;
  type: TicketType[];
  severity: TicketSeverity[];
  setTitle: (title: string) => void;
  setType: (type: TicketType[]) => void;
  setSeverity: (severity: TicketSeverity[]) => void;
  clearFilters: () => void;
  hasActiveFilters: boolean;
}

export function useTicketFilters(debounceMs: number): UseTicketFiltersReturn {
  const [title, setTitle] = useState('');
  const [debouncedTitle, setDebouncedTitle] = useState('');
  const [type, setType] = useState<TicketType[]>([]);
  const [severity, setSeverity] = useState<TicketSeverity[]>([]);

  // Debounce para el título
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedTitle(title);
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [title, debounceMs]);

  const clearFilters = useCallback(() => {
    setTitle('');
    setType([]);
    setSeverity([]);
  }, []);

  const hasActiveFilters = useMemo(
    () => Boolean(debouncedTitle || type.length > 0 || severity.length > 0),
    [debouncedTitle, type.length, severity.length],
  );

  return {
    title,
    debouncedTitle,
    type,
    severity,
    setTitle,
    setType,
    setSeverity,
    clearFilters,
    hasActiveFilters,
  };
}
